import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { User } from '../models/user';
import { UserResponse } from './models/user-response';
import { ServiceCallOptions, useCallOptions } from './models/service-call-options';
import { SearchResponse } from './models/search-response';
import { SearchResult } from '../models/search-result';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private http: HttpClient
  ) { }

  getUser(options?: ServiceCallOptions): Observable<User> {
    return this.http.get<UserResponse>(`${environment.apiBaseUrl}/user`, useCallOptions(options))
      .pipe(
        map(response => this.mapDataToModel(response))
      );
  }

  getUserById(id: string, options?: ServiceCallOptions): Observable<User> {
    return this.http.get<UserResponse>(`${environment.apiBaseUrl}/user/${id}`, useCallOptions(options))
      .pipe(
        map(response => this.mapDataToModel(response))
      );
  }

  searchUsers(terms: string, options?: ServiceCallOptions): Observable<SearchResult<User>> {
    return this.http.get<SearchResponse<UserResponse>>(
      `${environment.apiBaseUrl}/user/search/${encodeURIComponent(terms)}`, useCallOptions(options))
      .pipe(
        map(response => ({
          ...response,
          items: response.items.map(user => this.mapDataToModel(user))
        }))
      );
  }

  private mapDataToModel(response: UserResponse): User {
    return {
      ...response,
      stats: response.stats ? {
        ...response.stats,
        now: new Date(response.stats.now)
      } : null
    };
  }
}
